export default {
  es: {
    '400E01': 'Este ítem está en uso, por lo cual no puede ser eliminado.',
    '400LG01': 'El paciente no ha sido encontrado.',
    '400LG03': 'Ya existe un usuario con estos datos.',
    '400LG04': 'Este usuario no existe.',
    '400LG06': 'El código no coincide',
    '400LG07': 'Usuario bloqueado!',
    '400LG08': 'Okta: Se requiere enrolar al usuario',
    '400LG09': 'Okta: Error no identificado',
    '400LG10P':
      'Esta contraseña no cumple la politica de seguridad, por favor intenta con otra.',
    '400LG01P': 'Esta contraseña es muy común, por favor intenta con otra.',
    '400LG02P': 'La contraseña ha sido usada recientemente.',
    '400LGP01': 'Este es un paciente inactivo.',
    '400LGP02': 'Paciente pendiente por registro.',
    '400LGP03': 'Paciente pendiente por aprobar términos y condiciones.',
    '400LG11':
      'Recientemente se envió un mensaje SMS. Espere 30 segundos antes de volver a intentarlo.',
    '400LG12':
      'El correo y/o contraseña con obligatorios, uno de ellos esta vacio.',
    '400LG13':
      'El correo asociado no fue encontrado en la plataforma de autenticacion Okta.',
    '400LG14':
      'Recientemente se hizo una llamada telefónica. Espere 30 segundos antes de volver a intentarlo.',
    '400LG15':
      'Recientemente se envió un correo electrónico. Espere 10 segundos antes de volver a intentarlo.',
    '400LG16': 'Error de validación de API: Número de teléfono no válido',
    '400LG17': 'Este número de teléfono no es válido.',
    '400LG18':
      'Cada código sólo se puede utilizar una vez. Solicite un nuevo código e inténtelo de nuevo.',
    '400LG19':
      'Token de Okta no válido. Puede haberse vencido por inactividad.',
    '500LG01':
      'Sucedió un error inesperado en el proveedor de autenticación, por favor intente de nuevo en unos minutos.',
    '422LG01':
      'Datos de autenticación incorrectas, por favor verifique los datos.',
    '500LG02':
      'Sucedió un error inesperado en el servicio de autenticación, por favor intente de nuevo en unos minutos.',
    '500LG03':
      'Sucedió un error calculando parámetros de seguridad, por favor intente de nuevo en unos minutos.',
    roleNotFound: 'Rol no encontrado',
    'No code available': 'Lo sentimos, algo salió mal',
    patientNotFound: 'Paciente no encontrado',
    patientEventNotFound: 'Evento no encontrado'
  },
  en: {
    '400E01': 'This item is in use, therefore it cannot be removed.',
    '400LG01': 'Patient was not found.',
    '400LG03': 'An user with this data already exists.',
    '400LG04': 'User does not exists.',
    '400LG06': 'Invalid code',
    '400LG07': 'User Locked',
    '400LG08': 'Okta: User enrollment required',
    '400LG09': 'Okta: Unidentified error',
    '400LG10P':
      'This password does not comply with the security policy, please try another',
    '400LG01P': 'This is a common password, please try another password.',
    '400LG02P': 'Password has been used too recently.',
    '400LGP01': 'This is a inactive patient.',
    '400LGP02': 'Pending registration patient.',
    '400LGP03': 'Patient pending to approve terms and conditions.',
    '400LG11':
      'An SMS message was recently sent. Please wait 30 seconds before trying again.',
    '400LG12':
      'The email and password attributes are required in this context.)',
    '400LG13': 'Email not found (User))',
    '400LG14':
      'A phone call was recently made. Please wait 30 seconds before trying again.',
    '400LG15':
      'An email was recently sent. Please wait 10 seconds before trying again.',
    '400LG16':
      'Api validation failed: factorEnrollRequest - Invalid Phone Number.',
    '400LG17': 'This phone number is invalid.',
    '400LG18':
      'Each code can only be used once. Please wait for a new code and try again.',
    '400LG19': 'Invalid token provided.',
    '422LG01': 'Incorrect credentials, please verify the data.',
    '500LG01':
      'An unexpected error occurred in the authentication provider, please try again in a few minutes.',
    '500LG02':
      'An unexpected error occurred in the authentication service, please try again in a few minutes.',
    '500LG03':
      'An error occurred calculating security parameters, please try again in a few minutes.',
    roleNotFound: 'Role not found',
    'No code available': 'Sorry, something went wrong',
    patientNotFound: 'Patient not found',
    patientEventNotFound: 'Event not found'
  }
};
